import { Lock, Heart, Users, Sparkles } from "lucide-react";

export default function About() {
  const values = [
    {
      icon: Lock,
      title: "Privacy First",
      description:
        "Your location data belongs to you. We never sell or share your information with third parties.",
    },
    {
      icon: Heart,
      title: "Built with Care",
      description:
        "Connection should feel natural, not invasive. Every feature is designed with empathy and intention.",
    },
    {
      icon: Users,
      title: "Community Driven",
      description:
        "Built for real people living real lives. Your feedback shapes every update we make.",
    },
    {
      icon: Sparkles,
      title: "Simple & Smart",
      description:
        "Powerful features that work seamlessly in the background. Technology that stays out of your way.",
    },
  ];

  return (
    <section  className="py-24 bg-white min-h-screen">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">

          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6 tracking-tight">
              About Fuzz
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              We're reimagining how people stay connected in the real world.
              Fuzz combines social proximity with trusted safety features —
              bringing closeness, comfort, and peace of mind into one simple app.
            </p>
          </div>

          {/* Mission */}
          <div className="bg-gradient-to-br from-teal-50 via-emerald-50 to-teal-100 rounded-3xl p-8 md:p-12 mb-20 border border-teal-100">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                Our Mission
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                In a world where we're more “connected” than ever but feel further apart,
                Fuzz brings the magic of serendipity back to your everyday life.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mt-4">
                We help you discover when friends are nearby, keep your loved ones safe,
                and create real-world moments that matter — without being creepy or intrusive.
              </p>
            </div>
          </div>

          {/* Values Grid */}
          <div className="grid md:grid-cols-2 gap-8 mb-24">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div
                  key={index}
                  className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200 hover:shadow-2xl hover:shadow-emerald-100 transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-2xl flex items-center justify-center mb-6">
                    <Icon className="h-7 w-7 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    {value.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>

          {/* Why We Built Fuzz */}
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Why We Built Fuzz
            </h2>

            <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 md:p-12 border border-gray-200 text-gray-700 text-lg leading-relaxed space-y-6">
              <p>
                We've all had those moments — scrolling through social media only to
                realize a close friend was in the same neighborhood.
              </p>
              <p>
                Or worrying about a loved one's safety but not wanting to constantly
                check in. Or missing out on spontaneous meetups because no one knew
                you were nearby.
              </p>
              <p className="font-medium text-gray-900">
                Fuzz solves these everyday moments with elegance and respect.
                Because life's best connections happen when you're together —
                and sometimes, all you need is a gentle nudge to make it happen.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}